var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_box"},[_c('van-icon',{staticClass:"left_icon",attrs:{"name":"arrow-left"},on:{"click":_vm.back}}),_vm._v(" 竞猜押宝喝彩礼包抽奖 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }